import React from "react";
import { Box } from "@mui/material";

function Embed({ code }) {
	return (
		<Box
			className="embed"
			sx={{
				position: "relative",
				width: "100%",
				paddingTop: "65%",
				"& iframe": {
					position: "absolute",
					width: "100%",
					height: "100%",
					top: 0,
					left: 0,
				},
			}}
			dangerouslySetInnerHTML={{ __html: code }}
		></Box>
	);
}

export default Embed;
